import { EditorCtaAComponent } from './editor-cta-a/editor-cta-a.component';

export const LandingEditorModules = {
    'editorModules':{
        EditorCtaAComponentClass: EditorCtaAComponent,
        }
};